import { LOGO_URL } from "@/lib/api";

export function LogoMark({ small = false, size }) {
  const cls = size === "mega" ? "logo-image mega" : small ? "logo-image small" : "logo-image";
  return (
    <img
      className={cls}
      src={LOGO_URL}
      alt="GI Bharat — True Vision Welfare Society logo"
      data-testid="true-vision-logo"
    />
  );
}
